import { useLocalStorage } from '@uidotdev/usehooks';
import { FeatureFlag } from 'types/features';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

const STORAGE_KEY = 'learning-mode';

type LearningMode = {
    /** The tenant has the feature; without it the toggle is hidden and a stored "on" stays inert. */
    isAvailable: boolean;
    isEnabled: boolean;
    setIsEnabled: (isEnabled: boolean) => void;
};

/** Whether the user has switched learning mode on. Persisted per browser, shared by every subscriber. */
export function useLearningMode(): LearningMode {
    const isAvailable = useIsFeatureEnabled(FeatureFlag.LEARNING_MODE);
    const [isStoredEnabled, setIsEnabled] = useLocalStorage<boolean>(STORAGE_KEY, false);
    return { isAvailable, isEnabled: isAvailable && isStoredEnabled, setIsEnabled };
}
